// extracted by mini-css-extract-plugin
export var card = "_8z-1";
export var container = "_8z-0";